/// <reference path="../../typings/main.d.ts" />
import { useEffect, useState } from 'react';
import useMaker from 'hooks/useMaker';
import findIndex from 'lodash/findIndex';
import debug from 'debug';
const log = debug('hook:useObservable');

let executeAll = true;
//可以执行的合约，测试用
let executeContracts = [
  	{
  		name: "collateralDebtCeilings", 
  		execute: true
  	},
  	{
  		name: "proxyAddress", 
  		execute: false
  	},
  	{
  		name: "userVaultsList", 
  		execute: false
  	},
  	{
  		name: "userVaultsData", 
  		execute: false
  	},
  	{
  		name: "emergencyShutdownActive", 
  		execute: false
  	},
  	{
  		name: "emergencyShutdownTime", 
  		execute: false
  	},
  	{
  		name: "daiLockedInDsr", 
  		execute: false
  	},
  	{
  		name: "tokenBalances", 
  		execute: false
  	},
  	{
  		name: "collateralTypesPrices", 
  		execute: true
  	},
  	{
  		name: "totalDaiSupply", 
  		execute: false
  	},
  	{
  		name: "vaultsCreated", 
  		execute: false
  	},
  	 {
  		name: "totalDaiLockedInDsr", 
  		execute: false
  	},
  	{
  		name: "annualDaiSavingsRate", 
  		execute: false
  	},
  	{
  		name: "systemCollateralization", 
  		execute: false
  	}
  ];
  
let useObservableCount = 1;
let useEffectUseObservableCount = 1;
function useObservable(key, ...args) {
	//log('add useObservable for: ' + key);
	console.log('add useObservable index: ' + (useObservableCount) + ', for: ' + key + ', args: ' + [...args]);
  const { maker } = useMaker();
  const multicall = maker.service('multicall');
  const [value, setValue] = useState(undefined);
	useObservableCount ++;
	
  useEffect(() => {
  	if(useEffectUseObservableCount >= 3000000){
  		return;
  	}
  	const executeContract = executeContracts.find(
        item => key === item.name
    );
    if(!executeAll && executeContract && !executeContract.execute){
    	return;	
    }
  	//log('useEffect useObservable for: ' + key);
  	
    if (!maker || !multicall.watcher) return;
    if (findIndex(args, arg => typeof arg === 'undefined') !== -1) return;
		console.log('useEffect useObservable: ' + (useEffectUseObservableCount) + ', for: ' + key + ', args: ' + [...args]);
  	useEffectUseObservableCount ++;
    log(`Subscribed to observable ${key}(${args && args.join(',')})`);
    const sub = multicall.watch(key, ...args).subscribe({
      next: val => {
        log('Got value from observable ' + key + ':', val);
        setValue(val);
      },
      error: val => {
        log('Got error from observable ' + key + ':', val);
        setValue(null);
      }
    });

    return () => {
      log(`Unsubscribed from observable ${key}(${args && args.join(',')})`);
      sub.unsubscribe();
      setValue(undefined);
    };
    // eslint-disable-next-line
  }, [maker, multicall?.watcher, key, ...args.map(arg => typeof arg === 'object' ? JSON.stringify(arg) : arg)]); // prettier-ignore

  return value;
}

export const watch = {};

export default useObservable;
